import React from "react"

import { Container } from "@material-ui/core"
import Layout from "../components/Layout"

import Hero from "./../components/Hero"

// import rohit from "../assets/team/Rohit-Sakunia.png"
// import tj from "../assets/team/Tejender-Sharma.png"
import pk from "../assets/team/Priyabrata-Kuanr.png"
// import animesh from "../assets/team/Animesh-Mukherjee.png"
import pg from "../assets/team/Priyansha-Bagaria.png"
// import sb from "../assets/team/Shubhankar-Biswas.jpg"
import kannan from "../assets/team/Kannan-Ranganathan.jpg"
// import rakesh from "../assets/team/Rakesh-Kumar.jpg"
import gaurav from "../assets/team/Kumar-Gaurav.jpg"
import ashwin from "../assets/team/Ashwin-.jpg"
import puia from "../assets/team/Puia-Chhakchhuak.jpg"
import shailesh from "../assets/team/Shailesh.jpg"
import siva from "../assets/team/Siva.jpg"
import manish from "../assets/team/manish.jpg"

// import placeholder from "../assets/team/Placeholder.jpg"

const team = [
  {
    id: 1,
    pic: pk,
    name: "Priyabrata Kuanr",
    title: "Co-Founder & Chief Executive Officer",
    about:
      "IIT Kanpur Alumni. Extensive experience at Adobe, Target, Thomas White International Loves Algorithms, Dreams Technology, Builds Products Speaks Less",
  },
  {
    id: 7,
    pic: kannan,
    name: "Kannan Ranganathan",
    title: "Chief Product Officer",
    about:
      "Home-grown Elon Musk with attitude for responsible success. Thinker. Reader. Explorer. Lawrence Krauss fan Cloud Infrastructure specialist with a Masters degree in Computer Communication and Networks Texas A&M University",
  },
  /*
  {
    'id' : 2,
    'pic' : rohit,
    'name' : 'Rohit Sakunia',
    'title' : 'Co-Founder & Chief Business Officer',
    'about' : 'Xoogler Chaser, believes his sales target is his life. Digital Marketing Guru Can play Table tennis and cricket till others drop dead , MSD Fan, has an everlasting affair with his phone and shoes.'   
  },
  {
    'id': 3,
    'pic': tj,
    'name' : 'Tejender Sharma',
    'title' : 'Co-Founder & Chief Creative Officer',
    'about' : 'Can weave a shirt as well as he can weave a story Creative Director, Movie Lover, Script Writer, Story Teller In House Indian Independence expert'
  },
  {
    'id' : 4,
    'pic' : animesh,
    'name' : 'Animesh Mukherjee',
    'title' : 'Co-Founder & Chief Financial Officer',
    'about' : 'Miser by nature, Chartered Accountant by profession, Humanitarian by choice State topper, Holds an MBA too Controls the company wallet as efficiently as he runs his NGO Loyal to Bollywood Classic songs'
  },
  */
  {
    id: 14,
    pic: manish,
    name: "Manish Shukla",
    title: "Chief Technology Officer",
    about:
      "Another IIT Kanpur Alumni, with 18+ year experience in Industry. Has worked at Qwest, ThoughtWorks & Deserve. Adventure lover with Leadership qualities.",
  },
  {
    id: 13,
    pic: shailesh,
    name: "Shailesh Vaya",
    title: "Chief Scientific Officer",
    about:
      "IIT Delhi alumni with PHD from University of California, LA. An Entrepreneur, Researcher & Multiple Patent holder with Experience at Xerox. He loves solving Puzzles.",
  },
  {
    id: 5,
    pic: pg,
    name: "Priyansha Bagaria",
    title: "Chief Revenue Officer",
    about:
      "Priyansha possess a unique combination of technical knowledge in AI/ML and years of experience managing complex cloud migration programs. Working in a global environment has given her the opportunity to travel across and build a business network in 30 countries, spanning industries like manufacturing, retail and FMCG. Priyansha is extremely passionate about women empowerment, entrepreneurship, fitness and fashion.",
  },
  {
    id: 9,
    pic: ashwin,
    name: "Ashwin Chandrasekar ",
    title: "Chief Customer Officer",
    about:
      "Nothing excited Ashwin more than satisfied customer and delighted end users. Par excellence product thinker, innovator and strategist. When not working he can be found riding bikes, playing guitars or meditating.",
  },
  {
    id: 11,
    pic: puia,
    name: "Puia Chhakchhuak",
    title: "UX Lead",
    about:
      "Self-learned, naturally curious, detail-oriented design genius. Digital products are the food for his soul. His passion drives his designs. Never without great music around him, he lives by integrity and accountability.",
  },
  {
    id: 12,
    pic: siva,
    name: "Sivaramakrishna H",
    title: "Lead Data Scientist",
    about:
      "IIT Madras alumni. Has past work experience at Ocwen Financial Solutions. Data Scientist by profession and Traveller by passion. He is a bookworm.",
  },

]

const TeamCards = () => (
  <div>
    <ul className="team-members flex">
      {team.map(member => {
        return (
          <li key={member.id} className="xs-6 md-4 lg-3">
            <div>
              <div className="flip">
                <div className="flip-inner">
                  <div className="title">
                    <figure>
                      <img src={member.pic} alt={member.name} />
                    </figure>
                    <div className="heading">
                      <h5>
                        <b>{member.name}</b>
                      </h5>
                      <span className="green">{member.title}</span>
                    </div>
                  </div>
                  <div className="about">
                    <p>{member.about}</p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        )
      })}
    </ul>
  </div>
)

function Team() {
  return (
    <Layout
      cssClass="team-page"
      title="INVIZ AI Solutions | Our Team"
      description="We are a global software and intelligence consultancy company focused on building software, cloud and data solutions with intelligence."
    >
      <Hero>
        <h1>
          <strong>
            Our <span className="green">Team</span>
          </strong>
        </h1>
      </Hero>
      <section>
        <Container>
          <div className="text-center">
            <p>
              Our people are our strength and the most significant contributors
              to our success. Our culture of innovation, inspiration, and
              integrity flows throughout our organization. We operate in a
              dynamic industry that requires us to challenge ourselves and
              embrace new opportunities every day. To succeed, we have created a
              workplace that is equally dynamic where employees are challenged,
              respected and rewarded.
            </p>
            <br />
          </div>
          <TeamCards />
        </Container>
      </section>
    </Layout>
  )
}

export default Team
